import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import Button from '@/shared/components/Button';
import DelayedDateRangePicker from '@/shared/components/input/DelayedDateRangePicker';
import intlShape from '@/shared/utils/intlShape';
import messages from '../employeeMessages';

class SelectPeriodModal extends Component {
  state = {
    dateFrom: null,
    dateUntil: null,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    saving: PropTypes.bool,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    saving: false,
  };

  componentDidMount() {
    // Initialize with current month
    this.setState({
      dateFrom: moment().startOf('month'),
      dateUntil: moment().endOf('month'),
    });
  }

  handleDatesChange = ({ startDate, endDate }) => {
    this.setState({
      dateFrom: startDate,
      dateUntil: endDate,
    });
  };

  handleSave = () => {
    const { onSave } = this.props;
    const { dateFrom, dateUntil } = this.state;

    if (!dateFrom || !dateUntil) {
      return;
    }

    onSave({
      dateFrom: dateFrom.toISOString(),
      dateUntil: dateUntil.toISOString(),
    });
  };

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({
      dateFrom: null,
      dateUntil: null,
    });
    onClose();
  };

  isValidPeriod = () => {
    const { dateFrom, dateUntil } = this.state;
    return dateFrom && dateUntil && dateFrom.isBefore(dateUntil);
  };

  render() {
    const { show, intl, saving } = this.props;
    const { dateFrom, dateUntil } = this.state;

    return (
      <Modal show={show} onHide={this.handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage {...messages.SelectPeriod} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group row">
            <div className="col-sm-4">
              <label>
                <FormattedMessage {...messages.Period} />
              </label>
            </div>
            <div className="col-sm-8">
              <DelayedDateRangePicker
                startDate={dateFrom}
                startDateId="SelectPeriodModalDateFrom"
                endDate={dateUntil}
                endDateId="SelectPeriodModalDateUntil"
                onDatesChange={this.handleDatesChange}
                block
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleClose} disabled={saving}>
            <FormattedMessage {...messages.Cancel} />
          </Button>
          <Button
            onClick={this.handleSave}
            disabled={saving || !this.isValidPeriod()}
            btnClassName="btn-inverse"
            showProgress={saving}
          >
            <FormattedMessage {...messages.Export} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default injectIntl(SelectPeriodModal);
